









































import { Component, Vue, Prop } from 'vue-property-decorator';

import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';

@Component({
  components: { TeamLogo }
})
export default class CounterStrikePoints extends Vue {
  @Prop() private data!: any;

  public getRoundsDifference(point: any): string {
    const prefix = !!point.roundsDifference && point.roundsDifference > 0 ? `+` : ``;

    return `${prefix}${point.roundsDifference}`;
  }
}
